import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './style.css';

import Navbar from "./components/Navbar";
import Footer from './components/Footer';
import ScrollToTop from "./components/ScrollToTop";
import JourneySection from "./pages/JourneySection";
import JourneyStartsHere from './pages/JourneyStartsHere';
import ServicesSection from "./pages/ServicesSection";
import CityOfLightPremium from './pages/CityOfLightPremium';
import ExcellenceInMotion from './pages/ExcellenceInMotion';
import EliteStaysSection from './pages/EliteStaysSection';
import DrivenByPerfection from './pages/DrivenbyPerfection';
import TaxiFleetSection from "./pages/TaxiFleetSection";
import PlanYourJourney from './pages/PlanYourJourney';

import Sightseeing from './pages/Sightseeing';
import AirportTransfer from './pages/AirportTransfer';
import Packages from './pages/Packages';
import Outstation from './pages/Outstation';
import BookCab from './pages/BookCab';
import Gallery from './pages/Gallery';
import About from "./pages/About";
import BookNow from "./pages/BookNow";
import Payment from "./pages/Payment";
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditionas';
import RefundPolicy from './pages/RefundPolicy';
import WhatsAppCallIcon from './components/WhatsAppCallIcon';
// Initialize AOS
AOS.init({
  duration: 1000,
  once: true,
  offset: 100
});

// Home Component
function HomePage() {
  return (
    <>
      <JourneySection />
      <JourneyStartsHere />
      <ServicesSection />
      <CityOfLightPremium />
      <TaxiFleetSection />
      <ExcellenceInMotion />
      <EliteStaysSection />
      <DrivenByPerfection />
      <PlanYourJourney />
    </>
  );
}

function App() {
  useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <Router>
      <ScrollToTop /> {/* 🔥 ONE PLACE – FULL WEBSITE SCROLL FIX */}

      <div className="App">
        <Navbar />

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/sightseeing" element={<Sightseeing />} />
          <Route path="/airport-transfer" element={<AirportTransfer />} />
          <Route path="/outstation" element={<Outstation />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/book-cab" element={<BookCab />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/book-now" element={<BookNow />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
        </Routes>

        <Footer />
        <WhatsAppCallIcon/>
      </div>
    </Router>
  );
}

export default App;
